import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaArrowRight, FaBars, FaTimes
} from 'react-icons/fa';
import ThemeToggle from '../../Components/ThemeToggle';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="w-full fixed top-0 left-0 right-0 z-50 bg-white dark:bg-dark shadow-sm">
      {/* 2. Middle Info Bar - Hidden on Mobile */}
      <div className="hidden md:block bg-gradient-to-r from-gray-50 to-white dark:from-dark-800 dark:to-dark border-b border-gray-100 dark:border-gray-800 transition-colors duration-200">
        <div className="container mx-auto px-4 py-3 flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-12 h-12 flex items-center justify-center overflow-hidden transition-transform duration-300 group-hover:scale-105">
              <img src="/assets/images/aman-logo-new.png" alt="Aman Medical Complex Gilgit Logo" className="w-full h-full object-contain mix-blend-multiply dark:mix-blend-normal" />
            </div>
            <span className="text-lg font-extrabold text-[#002147] dark:text-white tracking-tight hidden sm:block group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors">Aman Medical Complex Gilgit</span>
          </Link>

          {/* Contact Info */}
          <div className="flex flex-wrap justify-center gap-4 lg:gap-6">
            {/* Emergency */}
            <div className="flex items-center gap-2.5 group cursor-pointer">
              <div className="w-10 h-10 rounded-full bg-primary-50 dark:bg-primary-900/20 border border-primary-100 dark:border-primary-900/30 flex items-center justify-center text-primary text-lg transition-all duration-300 group-hover:bg-primary-500 group-hover:text-white group-hover:scale-110 group-hover:shadow-lg">
                <FaPhoneAlt />
              </div>
              <div>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 font-medium uppercase tracking-wider">Emergency</p>
                <p className="text-sm font-bold text-[#002147] dark:text-white group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors whitespace-nowrap">+92-345 5558297</p>
              </div>
            </div>
            {/* Email */}
            <div className="flex items-center gap-2.5 group cursor-pointer">
              <div className="w-10 h-10 rounded-full bg-primary-50 dark:bg-primary-900/20 border border-primary-100 dark:border-primary-900/30 flex items-center justify-center text-primary text-lg transition-all duration-300 group-hover:bg-primary-500 group-hover:text-white group-hover:scale-110 group-hover:shadow-lg">
                <FaEnvelope />
              </div>
              <div>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 font-medium uppercase tracking-wider">Email</p>
                <p className="text-xs font-bold text-[#002147] dark:text-white group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors whitespace-nowrap">ehtishamglt@gmail.com</p>
              </div>
            </div>
            {/* Location */}
            <div className="flex items-center gap-2.5 group cursor-pointer">
              <div className="w-10 h-10 rounded-full bg-primary-50 dark:bg-primary-900/20 border border-primary-100 dark:border-primary-900/30 flex items-center justify-center text-primary text-lg transition-all duration-300 group-hover:bg-primary-500 group-hover:text-white group-hover:scale-110 group-hover:shadow-lg">
                <FaMapMarkerAlt />
              </div>
              <div>
                <p className="text-[10px] text-gray-500 dark:text-gray-400 font-medium uppercase tracking-wider">Location</p>
                <p className="text-xs font-bold text-[#002147] dark:text-white group-hover:text-primary-500 dark:group-hover:text-primary-400 transition-colors whitespace-nowrap">Gilgit, Pakistan</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Top Bar (Only visible on small screens) */}
      <div className="md:hidden flex justify-between items-center px-4 py-4 bg-white dark:bg-dark border-b border-gray-100 dark:border-gray-800">
        <Link to="/" className="flex items-center gap-2">
          <img src="/assets/images/aman-logo-new.png" alt="Logo" className="w-10 h-10 object-contain mix-blend-multiply dark:mix-blend-normal" />
          <span className="text-sm xs:text-base font-black text-[#002147] dark:text-white leading-tight">
            Aman Medical <br className="xs:hidden" /> Complex Gilgit
          </span>
        </Link>
        <div className="flex items-center gap-4">
          <ThemeToggle />
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)} 
            className="text-2xl text-[#002147] dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500 rounded p-1"
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      {/* 3. Bottom Navbar */}
      <nav className={`bg-[#007bff] transition-all duration-300 shadow-lg lg:py-0 py-4 ${isMenuOpen ? 'block' : 'hidden lg:block'}`}>
        <div className="container mx-auto flex flex-col lg:flex-row justify-between lg:items-center px-4">
          {/* Nav Links */}
          <nav aria-label="Main navigation" className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6 xl:gap-8 font-bold text-white/90">
            <Link to="/" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Home page">Home</Link>
            <Link to="/about" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to About Us page">About Us</Link>
            <Link to="/services" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Services page">Services</Link>
            <Link to="/doctors" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Doctors page">Doctors</Link>
            <Link to="/donate" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Donate page">Donate</Link>
            <Link to="/blog" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Blog page">Blog</Link>
            <Link to="/careers" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Careers page">Career</Link>
            <Link to="/contact" onClick={() => setIsMenuOpen(false)} className="py-2 lg:py-6 border-b-2 border-transparent hover:text-white hover:border-white/20 transition-all focus:outline-none focus:ring-2 focus:ring-white/50 rounded" aria-label="Navigate to Contact page">
              Contact
            </Link>
          </nav>

          {/* Right Section */}
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8 mt-4 lg:mt-0 pb-4 lg:pb-0">
            <Link to="/appointment" onClick={() => setIsMenuOpen(false)} className="group bg-white hover:bg-gray-100 text-[#007bff] px-5 py-2.5 rounded-full font-bold text-sm transition-all duration-300 hover:scale-105 active:scale-95 flex items-center justify-center gap-2 shadow-xl hover:shadow-white/20">
              Make An Appointment <FaArrowRight size={12} className="group-hover:translate-x-1 transition-transform" />
            </Link>
            <div className="hidden lg:block">
              <ThemeToggle />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
